var r = {
  __proto__: null,
  light: Object.freeze({
    scheme: {
      $white: "#FFF",
      $gray100: "#F2F3F6",
      $gray200: "#EAEBEE",
      $gray300: "#DCDEE3",
      $gray400: "#D1D3D8",
      $gray500: "#ADB1BA",
      $gray600: "#868B94",
      $gray700: "#4D5159",
      $gray900: "#212124",
      $carrot50: "#FFF5F0",
      $carrot100: "#FFE2D2",
      $carrot200: "#FFD2B9",
      $carrot300: "#FFBC97",
      $carrot400: "#FF9E66",
      $carrot500: "#FF7E36",
      $carrot600: "#FA6616",
      $yellow50: "#FFF7E6",
      $yellow500: "#FFC552",
      $yellow800: "#CE6400",
      $green50: "#E8FAF6",
      $green500: "#00B493",
      $green800: "#008C72",
      $red50: "#FFF3F2",
      $red800: "#E81300",
      $blue50: "#EBF7FA",
      $blue800: "#0A86B7"
    },
    semanticScheme: {
      background: "$white",
      backgroundLow: "$gray100"
    }
  }),
  dark: Object.freeze({
    scheme: {
      $white: "#212124",
      $gray100: "#2B2E33",
      $gray200: "#34373D",
      $gray300: "#43474F",
      $gray400: "#50545C",
      $gray500: "#6D717A",
      $gray600: "#868B94",
      $gray700: "#ADB1BA",
      $gray900: "#EAEBEE",
      $carrot50: "#EDE4E0",
      $carrot100: "#EDD3C4",
      $carrot200: "#EDC4AD",
      $carrot300: "#EDB08E",
      $carrot400: "#EE9561",
      $carrot500: "#ED7735",
      $carrot600: "#E96017",
      $yellow50: "#EDE6D6",
      $yellow500: "#EDB84E",
      $yellow800: "#C05F03",
      $green50: "#D8E9E5",
      $green500: "#03A88A",
      $green800: "#03836C",
      $red50: "#EDE2E2",
      $red800: "#D81403",
      $blue50: "#DBE6E9",
      $blue800: "#0C7EAB"
    },
    semanticScheme: {
      background: "$white",
      backgroundLow: "#17171A"
    }
  })
};

function e() {
  e = function e(r, _e) {
    return new a(r, void 0, _e);
  };

  var r = RegExp.prototype,
      n = new WeakMap();

  function a(r, e, t) {
    var c = new RegExp(r, e);
    return n.set(c, t || n.get(r)), o(c, a.prototype);
  }

  function c(r, e) {
    var t = n.get(e);
    return Object.keys(t).reduce(function (e, o) {
      return e[o] = r[t[o]], e;
    }, Object.create(null));
  }

  return t(a, RegExp), a.prototype.exec = function (e) {
    var t = r.exec.call(this, e);
    return t && (t.groups = c(t, this)), t;
  }, a.prototype[Symbol.replace] = function (e, t) {
    if ("string" == typeof t) {
      var o = n.get(this);
      return r[Symbol.replace].call(this, e, t.replace(/\$<([^>]+)>/g, function (r, e) {
        return "$" + o[e];
      }));
    }

    if ("function" == typeof t) {
      var a = this;
      return r[Symbol.replace].call(this, e, function () {
        var r = arguments;
        return "object" != typeof r[r.length - 1] && (r = [].slice.call(r)).push(c(r, a)), t.apply(this, r);
      });
    }

    return r[Symbol.replace].call(this, e, t);
  }, e.apply(this, arguments);
}

function t(r, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: r,
      writable: !0,
      configurable: !0
    }
  }), e && o(r, e);
}

function o(r, e) {
  return (o = Object.setPrototypeOf || function (r, e) {
    return r.__proto__ = e, r;
  })(r, e);
}

var n = ["white", "gray", "carrot", "yellow", "green", "red", "blue"],
    a = e(/\$([a-z]+)([1-9][0-9]+)$/, {
  Group: 1,
  Lightness: 2
});

function c(r) {
  var e, t;
  if ("$white" === r) return ["$white", "white", 0];
  var o = r.match(a),
      c = null == o || null == (e = o.groups) ? void 0 : e.Group,
      l = null == o || null == (t = o.groups) ? void 0 : t.Lightness;
  if (null == c || null == l) throw new TypeError("Invalid color token: " + r);
  if (!n.includes(c)) throw new TypeError(c + " is unknown color group");
  return [r, c, parseInt(l)];
}

function l(r, e) {
  for (var t = {}, o = 0, n = Object.entries(e); o < n.length; o++) {
    var a,
        c = n[o],
        l = c[1];
    t[c[0]] = null != (a = r[l]) ? a : l;
  }

  return Object.freeze(t);
}

export { r as colors, c as parseColorToken, l as populateSemanticColors };